<template>
    <main>
      <partnerHeaderComponent
        :lang="lang"
        :title="'pages.partner'"
      ></partnerHeaderComponent>
      <horizontalInfographic
        :lang="lang"
        :title="'pages.partner.why'"
        :id="'partner'"
      ></horizontalInfographic>
      <partnerPreferencesComponent
        :lang="lang"
        :title="'pages.partner'"
      ></partnerPreferencesComponent>
      <partnerFormComponent
        :lang="lang"
        :title="'pages.partner'"
        :id="'partner'"
      ></partnerFormComponent>
    </main>
  </template>
  <script>
  import partnerHeaderComponent from "@/components/partnerHeader/partnerHeader.vue";
  import partnerPreferencesComponent from "@/components/partnerPreferences/partnerPreferences.vue";
  import horizontalInfographic from "@/components/horizontalInfographic/horizontalInfographic.vue";
  import partnerFormComponent from "@/components/partnerForm/partnerForm.vue";
  import tr from "@/lang/tr.js";
  import en from "@/lang/en.js";
  export default {
    mixins: [tr, en],
    name: "PartnerView",
    components: {
      partnerHeaderComponent,
      partnerPreferencesComponent,
      horizontalInfographic,
      partnerFormComponent,
    },
    metaInfo() {
      return {
        title: this.metaTitle
          ? this.metaTitle
          : "KOBİSİ HIZLI E-TİCARET PLATFORMU PARTNER",
        meta: [
          {
            name: "description",
            content: this.metaDescription ? this.metaDescription : "",
          },
          {
            property: "og:title",
            content: this.metaTitle ? this.metaTitle : "KOBİSİ HIZLI E-TİCARET PLATFORMU PARTNER",
          },
          { name: "robots", content: "index,follow" },
          { property: "og:type", content: " MAKALE (MAKALE) " },
          { property: "og:title", content: " SAYFANIN BAŞLIĞI " },
          { property: "og:description", content: " İÇERİK AÇIKLAMASI " },
          { property: "og:image", content: " GÖRÜNTÜNÜN LİNKİ " },
          { property: "og:url", content: " PERMALINK " },
          { property: "og:site_name", content: " SİTE ADI " },
        ],
      };
    },
    data() {
      return {
        metaDescription: null,
        metaTitle: null,
      };
    },
    props: {
      lang: String,
      title: String,
      id: String,
    },
    beforeUpdate() {
      this.metaTitle = this[this.lang].pages.features.title;
      this.metaDescription = this[this.lang].pages.features.description;
    },
    mounted() {
      document.body.classList.add("features", "active-page");
      this.metaTitle = this[this.lang].pages.features.title;
      this.metaDescription = this[this.lang].pages.features.description;
    },
    destroyed() {
      document.body.classList.remove("features", "active-page");
    },
  };
  </script>
  <style>
  </style>